var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stat_minus_1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1074_1000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1074_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stat_minus_1_2",
    d: "M12.0001 14.702L6.69238 9.39427L7.40013 8.68652L12.0001 13.2808L16.6001 8.68652L17.3079 9.39427L12.0001 14.702Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDropdown);
export default __webpack_public_path__ + "static/media/open_dropdown.d2e3db8ee3ad96121b90ca83e15a08aa.svg";
export { ForwardRef as ReactComponent };